import React from "react";
import {Table, Input, Button, Icon, Row, Col, Tooltip, message, Modal, Dropdown, Menu, Divider,Switch} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import NHTable from '../../common/NHTable';
import {NHModal, NHConfirm} from '../../common/NHModal';
import {hasAuth,getLoginUser} from "../../../utils/NHCore";
import NHContainerFrame from '../../common/NHContainerFrame';
import EditForm from './EditForm.js';
import css from './index.css';


const confirm = Modal.confirm;
const baseUrlPath = "/fwwgl/sytp"; //TODO 把此处的信息改成自己的

class Sytp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            isAdd:true,
            frameVisibleMap:{
                tableFlag:true,
                addFlag:false,
                updateFlag:false,
                showFlag:false,
                showOperationBtn: false, //按钮显示标志
            }
        };
    }

    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap=this.state.frameVisibleMap;
        for(let name in frameVisibleMap){
            if(name==showFlagName){
                frameVisibleMap[name]=true;
            }else{
                frameVisibleMap[name]=false;
            }
        }
        this.setState({
            frameVisibleMap:frameVisibleMap
        });
    }

    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setState({ isAdd: true });
        this.setCurrentPageShow('addFlag');
    }
    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        let pkid = record.PKID;//TODO 把此处的信息改成自己的
        NHFetch(baseUrlPath + '/' + pkid + '/get', 'GET')
            .then(res => {
                if(res){
                    this.setState({formInitData: res.data});
                    this.setState({ isAdd: false });
                    this.setCurrentPageShow('updateFlag');
                }
            })
    }
   
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
       NHConfirm("是否确定删除这条数据？",() => {
           let pkid = record.PKID;//TODO 把此处的信息改成自己的
           this.handleDelete([pkid]);
       },"warn");
    }
    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if(selectedRowKeys && selectedRowKeys.length>0){
            NHConfirm("是否确定删除选中的多条数据？",() => {
                this.handleDelete(selectedRowKeys);
            },"warn");
        }else{
            message.warning("请先选择需要删除的数据！");
        }
    }
    //删除操作
    handleDelete = (pkids) => {
        NHFetch(baseUrlPath + '/deleteByMulti' , 'POST' , pkids)
            .then(res => {
                if (res) {
                    message.success("删除操作成功！");
                    this.setState({showOperationBtn: false});
                    this.refs.nhTable.filterTableData();
                }
            })
    }

     // table选择row后出现操作按钮
     rowSelectionChange = (selectedRowKeys) => {
        this.setState({
            showOperationBtn: selectedRowKeys.length ? true : false
        });
    };

    updateState = (record) => {
        NHFetch(baseUrlPath+"/insertOrUpdate","POST",{"pkid":record.PKID,"zt":record.ZT == '1' ? '0' : '1'})
            .then(res => {
                if (res && res.code == 200) {
                    message.success("操作成功");
                }else{
                    message.warn("操作异常");
                }
                this.refs.nhTable.readTableData();
            });
    }
    //新增 or 修改面板保存方法
    handleSaveAddOrUpdate = () => {
        this.refs.nhAddForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            let msg = "";
            if(!this.state.isAdd){
                formData.pkid = this.state.formInitData.pkid;
                msg = "修改成功！";
            }else{
                msg = "新增成功！";
            }
            NHFetch(baseUrlPath + '/insertOrUpdate' , 'POST' , formData)
                .then(res => {
                    if (res) {
                        message.success(msg);//TODO 把此处的信息改成自己的
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.filterTableData();
                    }
                })
        });
        
    }
   
    render() {
        //列参数
        const columns = [{
            title: '序号',
            width: '60px',
            dataIndex: 'ROW_ID'
        }, {
            title: '图片名称',
            width: '60px',
            dataIndex: 'tpmc'
        }, {
            title: '排序号',
            width: '60px',
            dataIndex: 'pxh'
        },
        {
            title: '状态',
            width: '60px',
            dataIndex: 'ztmc',
            render:(text,record,index) => {
                const status = record.ZT=='1' ? true:false;
                return (
                    hasAuth('zhxg_yxgl_fwwgl_sytp:update_state') ?   
                    <Switch checkedChildren="启用" unCheckedChildren="停用" checked={status} onChange={() => this.updateState(record)}/>
                    : <Switch checkedChildren="启用" unCheckedChildren="停用" checked={status} disabled={true}/>
                );
            }
        }];
        //行内操作
        const action = [
            {title:'修改',onClick:this.handleUpdateBtnClick,auth:'zhxg_yxgl_fwwgl_sytp:update'},
            {title:'删除',onClick:this.handleSingleDeleteBtnClick,auth:'zhxg_yxgl_fwwgl_sytp:delete'},
        ];
        return (
            <div className={css.main_right_content} style={{height:getSize().windowH-163}}>
                <div className={css.table} style={{display:this.state.frameVisibleMap.tableFlag?'block':'none'}}>
                    <NHTable ref='nhTable'
                             rowKey={record =>record.PKID} //TODO 把此处的信息改成自己的
                             sign={"zhxg_yxxt_fwwgl_sytp_queryPage"} //TODO 把此处的信息改成自己的
                             columns={columns}
                             action={action}
                             rowSelectionChange={this.rowSelectionChange}
                    >
                        {hasAuth('zhxg_yxgl_fwwgl_sytp:add')? <Button type="primary" onClick={this.handleAddBtnClick}>新增</Button> : null}
                        {(this.state.showOperationBtn && hasAuth('zhxg_yxgl_fwwgl_sytp:multi_delete')) && <Button type="danger" ghost style={{marginLeft:10}} onClick={this.handleMultiDeleteBtnClick}>删除</Button>}
                    </NHTable>
                </div>
                <NHContainerFrame ref="nhAddModal"
                         title="新增首页图片" //TODO 把此处的信息改成自己的
                         visible={this.state.frameVisibleMap.addFlag}
                         onOk={this.handleSaveAddOrUpdate}
                         onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhAddForm"/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhUpdateModal"
                         title="修改首页图片" //TODO 把此处的信息改成自己的
                         visible={this.state.frameVisibleMap.updateFlag}
                         onOk={this.handleSaveAddOrUpdate}
                         onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhAddForm" initFormData={this.state.formInitData}/>
                </NHContainerFrame>
            </div>
        );
    }
}
export default Sytp;



// WEBPACK FOOTER //
// ./components/fwwgl/sytp/index.js